module.exports = __webpack_public_path__ + "img/ico-circle-link.6e1b354f.svg";